import { __awaiter, __generator } from "tslib";
import { ltjsModule, registerModule, runWhenPlatformInitialized } from './ltjsEnvironment';
import CommonsPackage from './CommonsPackage';
import CommonsUIPackage from './CommonsUIPackage';
import { loadApplicationTheme } from './util/ThemeLoader';
registerModule('commons', [CommonsPackage, CommonsUIPackage]);
/**
 * Loads the sas-icons font if it's been declared but not yet loaded
 * @returns whether the font is loaded
 */
function loadSasIconsFont() {
    return __awaiter(this, void 0, void 0, function () {
        var fonts, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (sas.ltjs.node) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, document.fonts.load('12px sas-icons')];
                case 2:
                    fonts = _b.sent();
                    return [2 /*return*/, fonts.length > 0];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
loadSasIconsFont();
runWhenPlatformInitialized(function (platformInitCallback) {
    Promise.all([
        // Apply application theme before any visuals have been created to
        // prevent flash of cpp's hardcoded Raven theme
        new Promise(function (resolve) { return loadApplicationTheme(resolve); }),
        loadSasIconsFont(),
    ]).then(function () {
        var _a;
        platformInitCallback === null || platformInitCallback === void 0 ? void 0 : platformInitCallback();
        if (!sas.ltjs.node) {
            (_a = document.fonts) === null || _a === void 0 ? void 0 : _a.addEventListener('loadingdone', function (event) {
                // Safari doesn't support FontFaceSetLoadEvent and never fires
                // loadingdone. The FontFaceSetLoadEvent checks are in case loadingdone
                // is fixed before FontFaceSetLoadEvent is added.
                if (window.FontFaceSetLoadEvent &&
                    event instanceof window.FontFaceSetLoadEvent &&
                    event.fontfaces.some(function (font) { return font.family === 'sas-icons'; })) {
                    ltjsModule.module._ltjs_commons_ViewManager_invalidateAllViews();
                }
            });
        }
    });
}, true);
